var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14.001
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Filter",
    d: "M6 14.001h8v-2H6zm-3-6h14v-2H3zm-3-6h20v-2H0z",
    fill: "#000450"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iRmlsdGVyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNC4wMDEiIHZpZXdCb3g9IjAgMCAyMCAxNC4wMDEiPgogIDxwYXRoIGlkPSJGaWx0ZXItMiIgZGF0YS1uYW1lPSJGaWx0ZXIiIGQ9Ik02LDE0aDhWMTJINlpNMyw4SDE3VjZIM1pNMCwySDIwVjBIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC4wMDEpIiBmaWxsPSIjMDAwNDUwIi8+Cjwvc3ZnPgo=";
export { SvgFilter as ReactComponent };